// Whether the stage panel is hidden: while a puzzle holds the board, the
// stage's sections, the "Blunders and misses" rows first, would give the
// answer away, so the panel and the stage tabs' strip above it are hidden
// (display none, out of the tab order), and the right column shows only the
// puzzle card and the Learn card. They stay hidden once the puzzle is solved
// or shown, until "Back to the game" (2026-10-13; until then they came back
// on solving, which the user did not want: the puzzle's place in the column
// is the puzzle's until they leave it). The marker is the Best moves
// visibility constraint, which the puzzle holds at `visible: false` from
// start to "Back to the game" (puzzle-constraints.ts), where the Scoresheet
// visibility's `hideFrom` only lasts while the answer is to find. Until
// 2026-10-12 they were dimmed and inert instead. The selected tab stays.
// Pure, tested.

/** True while a Best moves visibility constraint hides them: a puzzle holds the board. */
export function isHidden(bestMoves: { visible?: boolean }): boolean {
  return bestMoves.visible === false;
}

/**
 * The event that hides the stage tabs' strip and its region with the panel,
 * or shows them again: the strip is the layout's (`layout.tabsHidden`), so
 * the whole right column under the puzzle card is gone until the puzzle is
 * left; the selected tab stays as it is.
 */
export function tabsHidden(slot: string, bestMoves: { visible?: boolean }): { slot: string; hidden: boolean } {
  return { slot, hidden: isHidden(bestMoves) };
}
